import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'


Vue.use(VueTheMask);
Vue.use(Vuelidate)

Vue.config.productionTip = false;
const VueUploadComponent = require('vue-upload-component');
Vue.component('file-upload', VueUploadComponent);
import './assets/bootstrap.min.css';
import './less/fonts.less';
import './less/main.less';
import {getSiteLocal} from "@/service/dataService";
import Register from "@/components/register/register.vue";
import Login from "@/components/login/login.vue";
import Dashboard from "@/components/dashboard/dashboard.vue";
import interest from "@/components/interest/interest.vue";
import Codecheck from "@/components/codecheck/codecheck.vue";

import '@babel/polyfill';
switch (getSiteLocal()) {
  case "login":
    new Vue({
      el: '#login',
      render: h =>h(Login)
    });
    break;
  case "register":
    new Vue({
      render(h) {
        return h(Register, { props: {} });
      },
      methods: {}
    }).$mount('#register');
    break;
  case "erdeklodes":
    new Vue({
      el: '#erdeklodes',
      render: h =>h(interest)
    });
    break;
  case "dashboard":
    new Vue({
      el: '#dashboard',
      render: h =>h(Dashboard)
    });
    break;
  case "code_check":
    new Vue({
      el: '#codecheck',
      render: h =>h(Codecheck)
    });
    break;


  default:

}
